import { LanguageIdOptions } from "../SubstantialChangesConstants";

export const mapSubstantialChangeTypeToRequestBody = (data: any) => ({
  id: data.id,
  isActive: data.isActive,
  sovereignOperationsId: data.operationType,
  translations: [
    {
      languageId: LanguageIdOptions.es,
      name: data.nameEs || data.translations?.find(t => t.languageId === LanguageIdOptions.es)?.name || '',
    },
    {
      languageId: LanguageIdOptions.en,
      name: data.nameEn || data.translations?.find(t => t.languageId === LanguageIdOptions.en)?.name || '' ,
    },
    {
      languageId: LanguageIdOptions.pt,
      name: data.namePt || data.translations?.find(t => t.languageId === LanguageIdOptions.pt)?.name || '' ,
    },
    {
      languageId: LanguageIdOptions.fr,
      name: data.nameFr || data.translations?.find(t => t.languageId === LanguageIdOptions.fr)?.name || '' ,
    }
  ]
});